import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';

import getFetchOptions from 'utils/getFetchOptions';

export default function updateTestCandidate(obj) {
	return fetch(
		`${ENDPOINT_URL}/updatecandidate`,
		getFetchOptions({
			method: 'PUT',
			body: JSON.stringify(obj),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
